import styled from 'styled-components';
import { FLEX_CENTERED } from '../../constants';
import {
  breakpoints,
  sideMenuWidth,
  headerHeightMobile,
  headerHeightDesktop
} from '../../styles';

export const MainContainer = styled.section`
  overflow-x: hidden;
  overflow-y: auto;
  /* mobile needs username dropdown space */
  padding-top: ${({ type }) =>
    type === FLEX_CENTERED ? null : `${headerHeightMobile * 2}rem`};

  @media only screen and (min-width: ${breakpoints.tablet}) {
    margin: 0;
    min-height: 100vh;

    ${({ type }) => {
      if (type === FLEX_CENTERED) {
        return `
          display: flex;
          justify-content: center;
          align-items: center;
        `;
      } else {
        return `
          padding-top: ${headerHeightDesktop}rem;
        `;
      }
    }}
  }

  .menu--visible ~ & {
    &,
    + footer {
      display: none;
    }
  }
`;

export const LayoutChildren = styled.div`
  @media only screen and (min-width: ${breakpoints.largeMonitor}) {
    transition: margin 0.3s ease;
    /* add margin let only when nav exists */
    nav + * > & {
      margin-left: ${({ menu }) => (menu ? sideMenuWidth : 0)}px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/Wrappers/Layout.style.js